import {
    NavController,
    NavParams,
    App,
    ModalController,
    ViewController,
    ToastController,
    Platform,
} from "ionic-angular";
import { Storage } from "@ionic/storage";
import { Component, OnInit, Input } from "@angular/core";
import { AuthProvider } from "../../../../../providers/auth/auth";
import { EmployeeRhProvider } from "../../../../../providers/employeerh/employeerh";
import { KnowledgeProvider } from "../../../../../providers/knowledge/knowledge";
import { CommonProvider } from "../../../../../providers/common";
import { InAppBrowser } from "@ionic-native/in-app-browser/ngx";

@Component({
    selector: "page-rh-knowledge-page",
    templateUrl: "knowledge-page.html",
})
export class RhKnowledgePagePage implements OnInit {

    page:any = null;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public storageProvider: Storage,
        public app: App,
        public authProvider: AuthProvider,
        public employeeRhProvider: EmployeeRhProvider,
        public viewCtrl: ViewController,
        public toastCtrl: ToastController,
        public modalCtrl: ModalController,
        private knowledgeProvider: KnowledgeProvider,
        private commonProvider: CommonProvider,
        private iab: InAppBrowser,
    ) {

    }

    ngOnInit() {
        this.loadDatas();
    }

    loadDatas() {
       this.knowledgeProvider.getPage(this.navParams.get('id')).subscribe((res) => {
           if (res.success) {
               this.page = res.data;
           }
       })
    }

    downloadFile(file){
        const browser = this.iab.create(this.commonProvider.s3PublicUrl + file.s3key, '_system', 'location=yes')
    }

    // Modal ctrl
    dismiss() {
        this.viewCtrl.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/pages/employee/_rh/rh-knowledge/knowledge-page/knowledge-page.ts